import {bool} from "prop-types";
import WithUserPermissions from "components/shared/WithUserPermissions/WithUserPermissions";
import React from "react";
import classnames from "classnames";

export const BrokerageLink = ({ isMobileLayout }) => {
    const className = classnames('brokerage-account-message', {
        isMobile: isMobileLayout
    });
    return (
        <div className={className} data-testid="brokerage-link-section">
            {isMobileLayout && (
                <div className="brokerage-header">Tax Information</div>
            )}
        </div>
    );
};

BrokerageLink.propTypes = {
    isMobileLayout: bool.isRequired
};

export const BrokerageLinkWithPermissions = WithUserPermissions(BrokerageLink);